import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignMagazineHotelArticleDefaultEditContainer } from "@/components/features/design/magazine/edit/about-hotel/default";
import { DesignMagazinePlanArticleDefaultEditContainer } from "@/components/features/design/magazine/edit/plan/default";
import { DesignMagazineRoomArticleDefaultEdit } from "@/components/features/design/magazine/edit/room/default";

import { useGetMagazinePageParams } from "./hooks/use-get-params";

export const DesignMagazineEditDefaultPage = () => {
	const { hotelID, magazineResourceID, magazineResourceType } = useGetMagazinePageParams();

	return (
		<PageMeta title="マガジンの編集" url={generatePath(PATHS.HOTEL.TOP, { hotelID })}>
			{magazineResourceType === "Plan" && (
				<DesignMagazinePlanArticleDefaultEditContainer hotelID={hotelID} planID={magazineResourceID} />
			)}
			{magazineResourceType === "AboutHotel" && (
				<DesignMagazineHotelArticleDefaultEditContainer hotelID={hotelID} />
			)}
			{magazineResourceType === "Room" && (
				<DesignMagazineRoomArticleDefaultEdit hotelID={hotelID} roomID={magazineResourceID} />
			)}
		</PageMeta>
	);
};

DesignMagazineEditDefaultPage.displayName = "DesignMagazineEditDefaultPage";
